import useFetch from 'utils/hooks/useFetch'
import { ApiLogin } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function AuthService() {
    const { showFail } = useModal()

    const { fetch: apiLogin } = useFetch(ApiLogin)
 
    const fetchLogin = async (username, password) => {
        const res = await apiLogin({
            data: {
                username,
                password
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchLogin,
    }
}